import { render, staticRenderFns } from "./HomeLoading.vue?vue&type=template&id=56ffb199"
import script from "./HomeLoading.vue?vue&type=script&lang=js"
export * from "./HomeLoading.vue?vue&type=script&lang=js"
import style0 from "./HomeLoading.vue?vue&type=style&index=0&id=56ffb199&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports